export default {
  backButton: 'All reports',
  title: 'Company Report',
  adminBackButton: 'Back to MBD Reports',
};
